export default __webpack_public_path__ + "static/media/logo-iac.dca97767.png";